export const mediaSrc = source => source?.startsWith('/api/')
  ? `${process.env.REACT_APP_BACKEND_URL}${source}`
  : source;